import { useCallback, useRef } from "react";

import awaitVerificationVerdict from "../logic/awaitVerificationVerdict";

export default function useAwaitVerificationVerdict({
  resolveOnGroupBlur,
  fetchInFlight,
}) {
  // Refs mirror the latest values so the returned (stable) callback reads the
  // freshest resolver/in-flight flag as the awaited Smarty fetch settles.
  const resolveOnGroupBlurRef = useRef(resolveOnGroupBlur);
  const fetchInFlightRef = useRef(fetchInFlight);
  resolveOnGroupBlurRef.current = resolveOnGroupBlur;
  fetchInFlightRef.current = fetchInFlight;

  return useCallback(
    () => awaitVerificationVerdict(resolveOnGroupBlurRef, fetchInFlightRef),
    []
  );
}
